import { Product, ProductDetail } from '../types';

// Use localhost for development, production domain for production
const API_BASE = process.env.REACT_APP_API_BASE || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:8787' : 'https://audioroom.mictest.workers.dev');

console.log('API_BASE configured as:', API_BASE);
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_BASE:', process.env.REACT_APP_API_BASE);

export class ApiService {
  static async getProducts(): Promise<Product[]> {
    console.log('Fetching products from:', `${API_BASE}/api/products`);
    const response = await fetch(`${API_BASE}/api/products`);
    if (!response.ok) {
      throw new Error(`Failed to fetch products: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    console.log('Products fetched:', data);
    return data;
  }

  static async getProduct(id: string): Promise<ProductDetail> {
    console.log('Fetching product details from:', `${API_BASE}/api/product/${id}`);
    const response = await fetch(`${API_BASE}/api/product/${id}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product details: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    console.log('Product details fetched:', data);
    return data;
  }

  static async getProductsByCategory(category: string): Promise<Product[]> {
    const products = await this.getProducts();
    console.log('Filtering for category:', category);
    console.log('Available categories:', Array.from(new Set(products.map(p => p.category))));
    
    const filtered = products.filter(product => {
      const productCategory = product.category.toLowerCase().replace(/[^a-z]/g, '_');
      const urlCategory = category.toLowerCase();
      
      console.log(`Checking product "${product.canonical_name}": category="${product.category}" -> normalized="${productCategory}", looking for="${urlCategory}"`);
      
      // Handle plural/singular matching
      if (urlCategory === 'turntables' && productCategory === 'turntable') return true;
      if (urlCategory === 'amplifiers' && productCategory === 'amplifier') return true;
      if (urlCategory === 'bookshelf_speakers' && productCategory === 'bookshelf_speakers') return true;
      
      // Fallback to exact match
      return productCategory === urlCategory;
    });
    
    console.log(`Found ${filtered.length} products for category "${category}"`);
    return filtered;
  }

  static async logClick(vendorListingId: string, productId?: string, vendorId?: string): Promise<void> {
    try {
      await fetch(`${API_BASE}/api/click`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          vendor_listing_id: vendorListingId,
          product_id: productId,
          vendor_id: vendorId,
        }),
      });
    } catch (error) {
      console.error('Failed to log click:', error);
    }
  }

  static formatPrice(price: number, currency: string = 'INR'): string {
    if (currency === 'INR') {
      return `₹${price.toLocaleString('en-IN')}`;
    }
    return `${price.toLocaleString()}`;
  }

  static getCategoryDisplayName(category: string): string {
    const categoryMap: Record<string, string> = {
      'bookshelf_speakers': 'Bookshelf Speakers',
      'turntables': 'Turntables',
      'amplifiers': 'Amplifiers',
      'speaker': 'Speakers',
      'turntable': 'Turntables',
      'amplifier': 'Amplifiers',
    };
    return categoryMap[category.toLowerCase()] || category;
  }
}
